import { Injectable } from '@angular/core';

const LANGUAGE_KEY = 'language';

@Injectable({
  providedIn: 'root'
})

export class LanguageService {

  constructor() { }

  clean(): void {
    window.localStorage.clear();
  }

  public saveLang(lang: any): void {
    window.localStorage.removeItem(LANGUAGE_KEY);
    window.localStorage.setItem(LANGUAGE_KEY, lang);
  }

  public getLang(): any {
    const lang = window.localStorage.getItem(LANGUAGE_KEY);
    if (lang) {
      return lang
    }
    const defLang= navigator.language.split('-')[0];
    if(defLang=='es' || defLang=='en') return defLang
    return 'en'
  }


}
